/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/require-await */
import React from 'react';
import { handleClusterClick, useCluster } from './clustering';
import { MapMarkerContainer } from './MapMarkerList.styled';
import { ClusterMarker } from '../MapMarker/ClusterMarker';
import { MapMarker } from '../MapMarker/MapMarker';
import mapContext from '../../../contexts/map-context';
import { handleMapMarkerClick } from './MapMarkerList.handlers';
import { Dealer } from '../../../models/dealer';
import trackingContext from '../../../contexts/tracking-context';
import {
  trackDealerDetailsDisplayAction,
  trackMapMarkerClickAction,
} from '../../../utils/trackingUtils';
import { useURLService } from '../../../hooks/useURLService';

// Couldn't make this function a React component due to a combination of React and GoogleMapReact
// limitation, GoogleMapReact will iterate though its children for adding positions for markers,
// but React doesn't allow returning multiple components so you need to wrap all of them in a
// Fragment.
// By wrapping the MapMarkers in a Fragment GoogleMapReact will iterate through only
// one child which is the Fragment.
// Thus we have this solution for separating the MapMarkerList from the main Map component

export const generateMapMarkerList = () => {
  const {
    selectedDealerId,
    hoveredDealer,
    results: dealers,
    groupMarkers,
    mapZoom,
    bounds,
    searchText,
    userSelectedFilters,
  } = mapContext.useMapState();

  const { trackingService: tService } = trackingContext.useTrackingState();

  const { clusters, supercluster } = useCluster(dealers || [], bounds, mapZoom, groupMarkers);
  const onMarkerClick = handleMapMarkerClick();
  const onClusterClick = handleClusterClick(supercluster);
  const generateURL = useURLService();

  async function handleClick(properties: Dealer) {
    const currentUrl = window.location.href;
    const { name, dealerId, kvpsId, country } = properties;
    const payload = {
      query: searchText,
      filters: userSelectedFilters,
      'dealer-id': dealerId,
      selected: kvpsId,
      country,
    };
    const url = generateURL(currentUrl, payload);
    onMarkerClick(properties);
    trackMapMarkerClickAction(tService, name, 'MapMarker', url.href);
    trackDealerDetailsDisplayAction(tService, properties);
  }

  return clusters?.map(({ id, geometry, properties }) => {
    const lat = geometry.coordinates[1];
    const lng = geometry.coordinates[0];
    const key = properties.dealerId || id || null;
    const isMarkerSelected = selectedDealerId === properties.dealerId;
    const isMarkerHovered = hoveredDealer?.dealerId === properties.dealerId;

    return (
      <MapMarkerContainer key={key} lat={lat} lng={lng}>
        {properties.cluster ? (
          <ClusterMarker
            numDealers={properties.point_count}
            onClick={() => onClusterClick(id as number, { lat, lng })}
          />
        ) : (
          <MapMarker
            dealer={properties}
            isSelected={isMarkerSelected}
            isHovered={isMarkerHovered}
            onClick={() => handleClick(properties as Dealer)}
          />
        )}
      </MapMarkerContainer>
    );
  });
};
